<div class="mbs-agent-installation">
  <ng-container *ngIf="!initialLoading; else loader">
    <mbs-card customClasses="bg-gray-10"
              [size]="'sm'"
              [hasPadding]="false">
      <h4 class="fw-bold border-bottom p-3">
        {{ 'wizards:onboarding.installationStep.title' | i18next : { format: 'title' } }}
      </h4>

      <div class="row p-3">
        <div *ngFor="let item of buildsSelectionConfig"
             class="col-3">
          <mbs-tile class="mbs-agent-installation_distr cursor-pointer"
                    [autoDeselect]="false"
                    [borderPadding]="'none'"
                    [borderedSelected]="true"
                    [data]="null"
                    [disabled]="false"
                    [headerTemplate]="buildHeaderTemplate"
                    [showBody]="false"
                    [selectable]="true"
                    [selected]="selectedBuild?.buildType === item.buildType"
                    (click)="onSelectedBuildChange(item)">
            <ng-template #buildHeaderTemplate>
              <div class="d-flex flex-column align-items-center flex-grow-1 pt-lg-1">
                <span class="fa fa-{{ item.os }} mbs-agent-installation_distr-icon"></span>
                <div class="pt-3 fw-semibold text-lg">{{ item.name }}</div>
              </div>
            </ng-template>
          </mbs-tile>
        </div>
      </div>
      <div *ngIf="selectedBuild"
           class="p-3">
        <ng-container *ngTemplateOutlet="buildDescription" />
      </div>
    </mbs-card>

    <mbs-card *ngIf="currentBuild$.getValue()"
              customClasses="bg-gray-10 mt-3"
              [size]="'sm'"
              [hasPadding]="false">
      <h4 class="fw-bold border-bottom p-3">{{ 'wizards:onboarding.installationStep.downloadTitle' | i18next }}</h4>

      <div class="d-flex align-items-center justify-content-between p-3"
           [class.border-bottom]="downloadInitiated"
           [class.border-2]="downloadInitiated"
           [class.mb-3]="downloadInitiated"
           [class.pb-3]="downloadInitiated">
        <div class="d-flex align-items-center">
          <span class="mbs-agent mbs-agent_backup mbs-agent-installation_backup-icon"></span>
          <div class="d-flex flex-column ml-2">
            <span
                  class="fw-bold">{{ 'wizards:onboarding.installationStep.backupAgentFor' | i18next : { os: selectedBuild.name } }}</span>
            <span *ngIf="currentBuild$.getValue().mbsBuildType === selectedBuild.buildType"
                  class="text-gray">
              v{{ currentBuild$.getValue()?.public?.version || currentBuild$.getValue()?.sandbox?.version }}
            </span>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <mbs-button (click)="downloadBuild()">
            <span class="fa fa-download"></span>
            {{'wizards:onboarding.installationStep.downloadButton' | i18next}}
          </mbs-button>
          <mbs-button class="ml-2"
                      [ngbTooltip]="'wizards:onboarding.installationStep.copyLink' | i18next"
                      (click)="copyDownloadLink(this.getDownloadLink())"
                      [icon]="'fa fa-share-alt'"></mbs-button>
        </div>
      </div>

      <div *ngIf="downloadInitiated"
           class="px-3 pb-3">
        <div class="d-flex justify-content-between">
          <div class="flex-grow-1 flex-basis-0 mr-3">
            <span class="fw-bold d-inline-block mb-2">{{ 'wizards:onboarding.installationStep.installation' | i18next }}</span>
            <ul class="mb-0">
              <li>{{ 'wizards:onboarding.installationStep.firstInstallationInfo' | i18next }}</li>
              <li>{{ 'wizards:onboarding.installationStep.secondInstallationInfo' | i18next }}</li>
              <li>{{ 'wizards:onboarding.installationStep.thirdInstallationInfo' | i18next }}</li>
            </ul>
          </div>
          <span class="text-gray">
            <span class="fa fa-clock-o"></span>
            {{ 'wizards:onboarding.installationStep.waitingInstall' | i18next }}
          </span>
        </div>
      </div>
    </mbs-card>

    <mbs-card *ngIf="!currentBuild$.getValue()"
              customClasses="bg-gray-10 mt-3"
              [size]="'sm'"
              [hasPadding]="false">
      <div class="d-flex align-items-center justify-content-center flex-column mt-3 pb-3">
        <span class="loader loader-lg"></span>

        <span class="mt-2">
          {{(currentBuild$.getValue() ? 'wizards:installationStep.installationStatus' :
          'wizards:installationStep.buildIsGenerated') | i18next}}
          <span *ngIf="!currentBuild$.getValue()"> {{'wizards:installationStep.wait' | i18next}} </span>
        </span>
      </div>
    </mbs-card>
  </ng-container>

  <ng-template #loader>
    <mbs-loader></mbs-loader>
  </ng-template>

  <ng-template #buildDescription>
    <ng-container [ngSwitch]="selectedBuild.buildType">
      <div *ngSwitchCase="buildType.CommonWindowsBuild">
        <div class="form-row">
          <div class="col-4 text-gray">
            {{ 'shared:sidePanelDownloads.supported_os' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of windowsSupported">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-4 pr-5 text-gray">
            {{ 'shared:builds.windows.can_backup_description' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of windowsCanBackup">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="buildType.LinuxMac">
        <div class="form-row">
          <div class="col-4 text-gray">
            {{ 'shared:sidePanelDownloads.supported_os' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of macOsSupported">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="buildType.LinuxRedHat6">
        <div class="form-row">
          <div class="col-4 text-gray">
            {{'shared:builds.linux_rpm.supported_os' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of linuxRpmSupported">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="buildType.LinuxUbuntu14">
        <div class="form-row">
          <div class="col-4 text-gray">
            {{'shared:builds.linux_deb.supported_os' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of linuxDebSupported">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="buildType.RMMAgent">
        <div class="form-row">
          <div class="col-4 text-gray">
            {{'shared:sidePanelDownloads.supported_os' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of windowsRmmSupported">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="buildType.RMMAgentMac">
        <div class="form-row">
          <div class="col-4 text-gray">
            {{'shared:sidePanelDownloads.supported_os' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of macRmmSupported">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="buildType.RMMAgentLinuxDeb">
        <div class="form-row">
          <div class="col-4 text-gray">
            {{'shared:sidePanelDownloads.supported_os' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of linuxDebRmmSupported">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="buildType.RMMAgentLinuxRpm">
        <div class="form-row">
          <div class="col-4 text-gray">
            {{'shared:sidePanelDownloads.supported_os' | i18next }}:
          </div>
          <div class="col-8">
            <ul class="mbs-agent-installation_tooltip-list pl-0 mb-0">
              <li *ngFor="let item of linuxRpmRmmSupported">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>
</div>
